import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { DocType } from '@tencent/docs-mime-types';
import { UserRole } from '..';
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { requestV1Cgi } from "../data-source/network-request";
import { COLLABORATION_SPACE_KIND } from "../model/collaboration-space";
import { DRIVE_FOLDER_KIND, FOLDER_ATTRIBUTE } from "../model/drive-folder";
import { UNKNOWN_USER, UNKNOWN_USER_NICK } from "../model/user";
import { convertTimestamp } from "../utils/date";
/**
 * 获取共享空间列表.
 */
export function getSpaceList(params) {
  return new SpaceListRequest(params).send();
}
export var GroupType = /*#__PURE__*/function (GroupType) {
  GroupType[GroupType["QQGroup"] = 1] = "QQGroup";
  GroupType[GroupType["QQDiscuss"] = 2] = "QQDiscuss";
  GroupType[GroupType["DocGroup"] = 3] = "DocGroup";
  GroupType[GroupType["WxWorkDepartment"] = 4] = "WxWorkDepartment";
  GroupType[GroupType["PrivateGroup"] = 5] = "PrivateGroup";
  return GroupType;
}({});
/**
 * 拉取共享空间列表
 */
export var SpaceListRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(SpaceListRequest, _DriveRequest);
  var _super = _createSuper(SpaceListRequest);
  function SpaceListRequest() {
    _classCallCheck(this, SpaceListRequest);
    return _super.apply(this, arguments);
  }
  _createClass(SpaceListRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: '/api/list/collaboration',
        data: {
          offset: params.offset,
          count: params.limit,
          xsrf: getXsrfToken()
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      var _this = this;
      return {
        items: response.result.files.map(function (item) {
          return _this.getFileNode(item);
        }),
        hasNext: !response.result.finish
      };
    }
  }, {
    key: "getFileNode",
    value: function getFileNode(item) {
      var _meta$group_info, _meta$group_info$grou, _meta$group_info2;
      var meta = item.meta,
        is_owner = item.is_owner;
      var fileNode = {
        kind: COLLABORATION_SPACE_KIND,
        id: meta.file_id,
        title: meta.name,
        collaborationFlag: meta.collaboration_flag,
        createTs: convertTimestamp(meta.create_time),
        creator: UNKNOWN_USER,
        docType: DocType.Unknown,
        groupInfo: {
          groupType: (_meta$group_info = meta.group_info) === null || _meta$group_info === void 0 ? void 0 : _meta$group_info.group_type,
          groupId: (_meta$group_info$grou = (_meta$group_info2 = meta.group_info) === null || _meta$group_info2 === void 0 ? void 0 : _meta$group_info2.group_id) !== null && _meta$group_info$grou !== void 0 ? _meta$group_info$grou : ''
        },
        iconUrl: meta.icon_url,
        lastBrowseTs: 0,
        lastDeleteTs: 0,
        lastModifyTs: convertTimestamp(meta.modify_time),
        lastModifier: {
          uid: meta.modify_uid,
          nick: UNKNOWN_USER_NICK
        },
        mimeType: item.mime_type,
        owner: {
          uid: meta.owner,
          nick: UNKNOWN_USER_NICK,
          avatarFrameUrl: '',
          expiredStatus: undefined,
          vipLevel: undefined,
          renewalStatus: undefined
        },
        originParentId: null,
        parentId: meta.file_parent_id,
        thirdAppId: null,
        isOwnedByMe: is_owner,
        attribute: null,
        roleId: UserRole.Unauthorized,
        displayName: meta.name
      };
      if (meta.is_folder && meta.collaboration_flag === 1) {
        return fileNode;
      }
      if (meta.is_folder) {
        Object.assign(fileNode, {
          kind: DRIVE_FOLDER_KIND,
          // 目前只能搜到自己的数据，因此文件夹都有权限
          attribute: FOLDER_ATTRIBUTE
        });
        return fileNode;
      }
      return fileNode;
    }
  }]);
  return SpaceListRequest;
}(DriveRequest);
//# sourceMappingURL=space-list.js.map